import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet framework
import { devConfig } from '../../../config/config'; // Importing development configuration from the config file

/**
 * Class representing a view for transfers.
 * @extends JetView
 */
export default class transfersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Get the current screen size configuration
        const screen = this.app.config.size;
        // Get the current theme configuration
        const theme = this.app.config.theme;
        // Initialize a variable to hold the type
        var type = '';
        // Define the layout for the left section of the UI
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a1',
                            cols: [
                                {
                                    // Text input for the amount
                                    view: 'text',
                                    name: 'Amount',
                                    type: 'number',
                                    label: _('Valor'), // Localized label for the input
                                    labelPosition: 'top',
                                    required: true, // Marked as required
                                    invalidMessage: _('Valor Invalido'), // Message shown when input is invalid
                                },
                            ],
                        },
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a1',
                            cols: [
                                {
                                    // Text input for confirming the amount
                                    view: 'text',
                                    name: 'AmountConfirm',
                                    type: 'number',
                                    label: _('Confirmar Valor'), // Localized label for the input
                                    labelPosition: 'top',
                                    required: true, // Marked as required
                                    invalidMessage: _('Valor Invalido'), // Message shown when input is invalid
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a1',
                            cols: [
                                {
                                    // Text input for related transaction ID
                                    view: 'text',
                                    name: 'RelatedTransactionId',
                                    label: _('Id de transacción relacionada'), // Localized label for the input
                                    labelPosition: 'top',
                                    required: false, // Not required
                                },
                                {
                                    // Combo box for selecting a bank
                                    view: 'combo',
                                    name: 'BankId',
                                    minWidth: 200,
                                    label: "<span class='icon-shop'></span>" + _('Banco'), // Localized label with icon
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '), // Placeholder text
                                    options: {
                                        body: {
                                            // Function to fetch bank options based on user input
                                            dataFeed: function (text) {
                                                var vthis = this;
                                                // Check if the input text is longer than 2 characters
                                                if (text.length > 2) {
                                                    // Make an AJAX request to fetch bank data
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'es/Select/BanksSelect',
                                                            '{"Filter":"' + text + '"}',
                                                            {
                                                                // Error handling for the AJAX request
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Error! ', // Display error message
                                                                    );
                                                                },
                                                                // Success handling for the AJAX request
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var resp = JSON.parse(
                                                                        text, // Parse the response text to JSON
                                                                    );
                                                                    // Check if there was an error in the response
                                                                    if (!resp.HasError) {
                                                                        vthis.parse(
                                                                            resp.Data, // Parse the data into the combo box
                                                                        );
                                                                    } else {
                                                                        // Handle specific error codes
                                                                        if (resp.CodeError != 110012) {
                                                                            webix.message({
                                                                                text: resp.AlertMessage, // Display alert message
                                                                                title: _('¡Mensaje!'), // Localized title for the alert
                                                                                type: 'alert-error', // Type of alert
                                                                            });
                                                                        }
                                                                    }
                                                                },
                                                            },
                                                        );
                                                }
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        // Listen for the 'transfertSelected' event on the app instance
        this.on(this.app, 'transfertSelected', (filter) => {
            // Set the type based on the selected filter's id
            type = filter.id;
        });

        // Define button configuration
        const buttons = {
            margin: 10,
            cols: [
                { id: 'grav', gravity: 1 },
                {
                    // Button for transferring funds
                    view: 'button',
                    value: _('Transferir'), // Button label
                    type: 'form', // Button type
                    width: screen == 'small' ? 0 : 130, // Conditional width based on screen size
                    minWidth: 200, // Minimum width of the button
                    click: () => {
                        // Validate the form before proceeding
                        if ($$('formPagoPremio').validate()) {
                            // Get values from the form
                            const newRecarga = this.getRoot().getValues();
                            // Retrieve the current user parameter
                            const cur_user = this.getParam('user', true);
                            var vthis = this; // Preserve context for use in callbacks

                            // Check if the amount and confirmation amount match
                            if (newRecarga.Amount === newRecarga.AmountConfirm) {
                                // Show confirmation dialog
                                webix.confirm({
                                    type: 'confirm-warning',
                                    text:
                                        _('Advertencia!') +
                                        '<br/>' +
                                        _('Confirme recarga de ') +
                                        newRecarga.Amount +
                                        ' ' +
                                        newRecarga.Currency +
                                        _(' para el usuario ') +
                                        newRecarga.Name,
                                    ok: _('Transferir'), // Confirm button label
                                    cancel: _('Salir'), // Cancel button label
                                    callback: function (action) {
                                        // If confirmed, proceed with the transfer
                                        if (action === true) {
                                            // Prepare data for the transfer
                                            const data = {
                                                Id: newRecarga.Id,
                                                Type: '1',
                                                Amount: newRecarga.Amount,
                                                AmountConfirm: newRecarga.AmountConfirm,
                                                BankId: newRecarga.BankId,
                                            };
                                            // Make an AJAX request to transfer funds
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(devConfig.geturlApi() + 'Agent/MakeAgentTransfers', data, {
                                                    // Handle error response
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(_('¡Error!')); // Show error message
                                                    },
                                                    // Handle success response
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse JSON response
                                                        // Check for errors in the response
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error, comuniquese con soporte'),
                                                            });
                                                        } else {
                                                            webix.message(_('Guardado')); // Show success message
                                                            // Create and show a window for the invoice
                                                            webix
                                                                .ui({
                                                                    view: 'window',
                                                                    head: {
                                                                        view: 'toolbar',
                                                                        cols: [
                                                                            {
                                                                                view: 'label',
                                                                                label: _('Factura'), // Window title
                                                                            },
                                                                            {
                                                                                view: 'button',
                                                                                label: 'X', // Close button label
                                                                                width: 100,
                                                                                align: 'right',
                                                                                click: "$$('windowfact2').close();", // Close window action
                                                                            },
                                                                        ],
                                                                    },
                                                                    id: 'windowfact2', // Window ID
                                                                    width: 800, // Window width
                                                                    height: 500, // Window height
                                                                    modal: true, // Modal window
                                                                    position: 'center', // Center position
                                                                    body: {
                                                                        rows: [
                                                                            {
                                                                                // Iframe for displaying the PDF
                                                                                template:
                                                                                    '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>',
                                                                            },
                                                                        ],
                                                                    },
                                                                })
                                                                .show(); // Show the window

                                                            var reader = new FileReader(); // Create a FileReader instance
                                                            reader.onload = function (event) {
                                                                // Clear and parse the PDF data into the iframe
                                                                $$('pdf').clear();
                                                                $$('pdf').parse({
                                                                    data: event.target.result,
                                                                });
                                                            };

                                                            // Function to convert base64 to Blob
                                                            function b64toBlob(b64Data, contentType, sliceSize) {
                                                                contentType = contentType || '';
                                                                sliceSize = sliceSize || 512;
                                                                var byteCharacters = atob(b64Data); // Decode base64
                                                                var byteArrays = [];
                                                                for (
                                                                    var offset = 0;
                                                                    offset < byteCharacters.length;
                                                                    offset += sliceSize
                                                                ) {
                                                                    var slice = byteCharacters.slice(
                                                                        offset,
                                                                        offset + sliceSize,
                                                                    );
                                                                    var byteNumbers = new Array(slice.length);
                                                                    for (var i = 0; i < slice.length; i++) {
                                                                        byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                    }
                                                                    var byteArray = new Uint8Array(byteNumbers); // Create a byte array
                                                                    byteArrays.push(byteArray); // Add to the array
                                                                }
                                                                var blob = new Blob(byteArrays, {
                                                                    type: contentType,
                                                                }); // Create a Blob from the byte arrays
                                                                return blob; // Return the Blob
                                                            }

                                                            var contentType = 'application/pdf'; // Set content type for PDF
                                                            var b64Data = json.Pdf; // Get base64 PDF data from response
                                                            var blob = b64toBlob(b64Data, contentType); // Convert base64 to Blob
                                                            var file = window.URL.createObjectURL(blob); // Create a URL for the Blob
                                                            document.querySelector('iframe').src = file; // Set the iframe source to the Blob URL
                                                            var printWindow = window.open(
                                                                file,
                                                                '',
                                                                'width=800,height=500',
                                                            ); // Open a new window for printing
                                                            printWindow.print(); // Trigger print dialog
                                                            vthis.getRoot().clear(); // Clear the form

                                                            // Remove CSS classes from buttons
                                                            webix.html.removeCss($$('button1').$view, 'green');
                                                            webix.html.removeCss($$('button2').$view, 'green');

                                                            // Hide various forms and show the consult section
                                                            $$('formPagoPremio1').hide();
                                                            $$('formPagoPremio').hide();
                                                            $$('formPago').hide();
                                                            $$('back-button').hide();
                                                            $$('consult-section').show();

                                                            // Trigger a custom event indicating success
                                                            vthis.app.callEvent('TransferAgentSuccess', []);
                                                        }
                                                    },
                                                });
                                        }
                                    },
                                });
                            } else {
                                // Show error message if amounts do not match
                                webix.message({
                                    title: _('¡Error!'),
                                    type: 'alert-error',
                                    text: _('Los montos no coinciden'),
                                });
                            }
                        } else {
                            // Show error message if form validation fails
                            webix.message({
                                title: _('¡Error!'),
                                type: 'alert-error',
                                text: _('Completa los campos...'),
                            });
                        }
                    },
                },
            ],
        };
        // Define the upper section configuration for the form
        const upper_section = {
            // CSS class for styling the container
            css: 'father-container',
            // Height of the section based on screen size
            height: screen == 'small' ? 150 : 0,
            // Columns to be included in the upper section
            cols: [left],
        };

        // Return the form configuration object
        return {
            // Type of view being created
            view: 'form',
            // Unique identifier for the form
            id: 'formPagoPremio',
            // Rows to be displayed in the form, including the upper section and buttons
            rows: [upper_section, buttons],
            // Validation rules for form fields
            rules: {
                // Rule for validating the Amount field
                Amount: function (value) {
                    // Amount must be greater than or equal to 0
                    return value >= 0;
                },
                // Rule for validating the AmountConfirm field
                AmountConfirm: function (value) {
                    // AmountConfirm must be greater than or equal to 0
                    return value >= 0;
                },
            },
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view and its components.
     * @param {Object} form - The form object to initialize.
     */
    init(form) {
        // Hide the payment form element with the ID 'formPagoPremio'
        $$('formPagoPremio').hide();

        // Listen for 'agentForm:data' event on the application instance
        this.on(this.app, 'agentForm:data', (premio) => {
            // Set the form values with the received 'premio' data
            form.setValues(premio);
            // Log the 'premio' data to the console for debugging purposes
            console.log('premio', premio);
        });

        // Execute the following code when the Webix library is ready
        webix.ready(function () {
            // Check if the screen width is less than 500 pixels
            if (screen.width < 500) {
                // Hide the element with the ID 'grav' if the condition is met
                $$('grav').hide();
            }
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
